import { FC, HTMLAttributes } from 'react';
import { Header, HeaderGroup } from '@tanstack/react-table';
import classNames from 'classnames';
import EmptyCell from '../EmptyCell/EmptyCell';
import st from './Header.module.scss';
import Resizer from '../Resizer/Resizer';

interface IHeaderFilterRowProps extends HTMLAttributes<HTMLTableRowElement> {
	rowExpanding?: boolean;
	headerGroup: HeaderGroup<any>;
	renderFilter?: (columnId: string) => React.ReactNode;
}

const HeaderFilterRow: FC<IHeaderFilterRowProps> = (props) => {
	const {
		rowExpanding = false,
		headerGroup,
		renderFilter,
		children,
		className,
		...otherProps
	} = props;

	/** Рендер ячейки шапки таблицы  */
	const renderHeaderFilterCell = (header: Header<any, unknown>) => {
		const isFiltarable = header.column.getCanFilter();
		const _colSpan = header.colSpan;
		const isResizing = header.column.getIsResizing();
		return (
			<th
				key={'filter_' + header.id}
				colSpan={_colSpan}
				className={classNames(st.filterCell, {
					[st.filtrable]: isFiltarable,
				})}
			>
				{!header.isPlaceholder &&
					isFiltarable &&
					!!renderFilter &&
					renderFilter(header.id)}
				{header.column.getCanResize() && (
					<Resizer
						resizeHandler={header.getResizeHandler()}
						isResizing={isResizing}
					/>
				)}
			</th>
		);
	};

	return (
		<tr
			key={headerGroup.id + '_filters'}
			className={st.filterRow}
			{...otherProps}
		>
			{rowExpanding && <EmptyCell isHeader width={32} />}
			{headerGroup.headers.map((header) => {
				return renderHeaderFilterCell(header);
			})}
			<EmptyCell isHeader width={32} />
		</tr>
	);
};

export default HeaderFilterRow;
